<template>
  <ViewContainer :px="6">
    <!-- 하단 영역 페이지 최하단으로 -->
    <v-layout fill-height column justify-space-between>
      <v-flex>
        <!-- 제목 영역 -->
        <section class="page-title-box mt-7 mb-8">
          <h2>로그인이 필요합니다.</h2>
          <p>
            바이나우 로그인 또는 가입 후<br />
            선정산 서비스 이용이 가능합니다.
          </p>
        </section>

        <!-- 중간 영역 -->
        <section>
          <!-- 폼 영역 시작 -->
          <ValidationObserver v-slot="{ invalid, handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
              <!-- 아이디 -->
              <FormValidationInput
                :inputValue.sync="user.id"
                :valid="{ name: 'email', rules: 'required|email' }"
                autocomplete="username"
                placeholder="이메일 입력"
                tabindex="1"
                clearable
                class="mb-2"
              />

              <FormValidationInput
                :inputValue.sync="user.password"
                :passwordShow.sync="passwordShow"
                :valid="{ name: 'password', rules: 'required' }"
                autocomplete="current-password"
                placeholder="비밀번호 입력"
                tabindex="2"
                type="password"
              />

              <BasicButton
                id="btn__wr3igPwuIk6l14bkAouZdA=="
                :disabled="invalid || loading"
                :loading="loading"
                type="submit"
                class="submit"
              >
                로그인
              </BasicButton>
            </form>
          </ValidationObserver>
          <!-- 폼 영역 끝 -->

          <!-- 아이디 비밀번호 찾기 링크 -->
          <v-layout justify-center class="find-box mt-5">
            <router-link :to="{ name: 'auth/find/id' }" id="btn__cPbGCpjFt0iVSlSTphGMHA==">
              아이디 찾기
            </router-link>
            <p class="mb-0 mx-2">|</p>
            <router-link :to="{ name: 'auth/find/password' }" id="btn__fSScvAAIvUqxSUYmvF2xSA==">
              비밀번호 찾기
            </router-link>
          </v-layout>
        </section>
      </v-flex>

      <!-- 하단 영역 -->
      <v-layout align-end class="pb-10">
        <v-layout justify-space-between align-center class="notice">
          <span class="color--gray-80">아직 바이나우 회원이 아니신가요?</span>
          <v-btn
            text
            x-small
            color="primary"
            class="pa-0 ml-2 basic"
            :to="{ name: 'signup' }"
            id="btn__eXYRjIXLxkqrwAgrltJsVw=="
          >
            회원가입
          </v-btn>
        </v-layout>
      </v-layout>
    </v-layout>
  </ViewContainer>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  components: {
    FormValidationInput: () => import('@/components/common/form/FormValidationInput.vue'),
  },
  data() {
    return {
      user: {
        id: null,
        password: null,
      },
      passwordShow: false,
      loading: false,
    }
  },
  created() {
    _meta({
      title: '로그인',
      description: '바이나우 로그인 또는 가입 후 선정산 서비스 이용이 가능합니다.',
    })
  },
  methods: {
    ...mapActions('auth', ['signin']),
    ...mapActions('ui/toast', ['alert']),
    ...mapMutations('ui/toast', ['close']),
    ...mapMutations('ui/header', ['setBackAction']),
    async onSubmit() {
      if (this.loading) return

      try {
        this.close()
        this.loading = true

        await this.signin(this.user)

        this.$gtm.trackEvent({ event: 'login', loginMethod: 'email' })

        let redirectUri = this.$route.query.redirectUri
        if (redirectUri == null) {
          redirectUri = '/'
        }
        await this.$router.push({ path: redirectUri })
      } catch (e) {
        if (e.status === 400 && e.message === '주어진 자격 증명으로 로그인이 불가능합니다.') {
          this.alert('아이디 또는 비밀번호가 일치 하지 않습니다.')
          return
        }
        throw e
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.find-box a {
  font-size: 14px;
  text-decoration: none;
  color: $gray-90;
}
</style>
